// my web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBoHHwJFbaPbXKF3Jxw3hpVCZ6OjgYyjvw",
  authDomain: "city-psychiatric-hospital.firebaseapp.com",
  projectId: "city-psychiatric-hospital",
  storageBucket: "city-psychiatric-hospital.appspot.com",
  messagingSenderId: "122160076349",
  appId: "1:122160076349:web:7ad3b91d5f195d5ea1bc54"
};
export default firebaseConfig;